












import { defineComponent } from '@vue/composition-api';
import TtamTipBox from '@/components/common/tip-box/index.vue';

const name = 'ttam-promotion-pixel-conversion-tips';

export default defineComponent({
  name,
  components: { TtamTipBox },
  setup(props, { emit }) {
    const onLinkClick = () => {
      emit('link-click');
    };
    return {
      name,
      onLinkClick,
    };
  },
});
